import { render } from "./Reactions.vue?vue&type=template&id=06020e05&scoped=true"
import script from "./Reactions.vue?vue&type=script&lang=js"
export * from "./Reactions.vue?vue&type=script&lang=js"

import "./Reactions.vue?vue&type=style&index=0&id=06020e05&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06020e05"]])

export default __exports__